import { LocalizacaoDTO } from './LocalizacaoDTO';
import { ContatoDTO } from './ContatoDTO';
import { TransportePessoasDTO } from './TransportePessoasDTO';
import { VeiculoDTO } from './VeiculoDTO';
import { TipoServicoEnum, getEnumNameByDescription } from './TipoServicoEnum';
import { ServicoSubClienteDTO } from "@/api/assistencia24h/ServicoSubClienteDTO";
import { ClienteAdministrativoDTO } from "@/api/assistencia24h/ClienteAdministrativoDTO";

export class SolicitacaoServicoDTO {
  id?: number;
  idCliente: number;
  tipoServico: string;
  localizacao: LocalizacaoDTO;
  associadoNoLocal?: boolean;
  contato?: ContatoDTO;
  destino?: LocalizacaoDTO;
  motivo?: string;
  nomeSolicitante?: string;
  transportePessoas?: TransportePessoasDTO;
  veiculo?: VeiculoDTO;
  servicoSubCliente?: ServicoSubClienteDTO;
  tipoLocalRemocao?: string;
  liberadoRemocao?: boolean;
  rodaTravada?: boolean;
  veiculoEletrico?: boolean;
  amperagemVeiculo?: String;
  veiculoBlindado?: boolean;
  veiculoCarregado?: boolean;
  possuiFerramenta?: boolean;
  cliente?: ClienteAdministrativoDTO;
  idPrestador?: number;
  private constructor(
    idServico: number | undefined,
    idCliente: number,
    tipoServico: string,
    localizacao: LocalizacaoDTO,
    associadoNoLocal?: boolean,
    contato?: ContatoDTO,
    destino?: LocalizacaoDTO,
    motivo?: string,
    nomeSolicitante?: string,
    transportePessoas?: TransportePessoasDTO,
    veiculo?: VeiculoDTO,
    servicoSubCliente?: ServicoSubClienteDTO,
    tipoLocalRemocao?: string,
    liberadoRemocao?: boolean,
    rodaTravada?: boolean,
    veiculoEletrico?: boolean,
    amperagemVeiculo?: String,
    veiculoBlindado?: boolean,
    veiculoCarregado?: boolean,
    possuiFerramenta?: boolean,
    cliente?: ClienteAdministrativoDTO,
    idPrestador?: number
  ) {
    this.id = idServico;
    this.associadoNoLocal = associadoNoLocal;
    this.contato = contato;
    this.destino = destino;
    this.idCliente = idCliente;
    this.localizacao = localizacao;
    this.motivo = motivo;
    this.nomeSolicitante = nomeSolicitante;
    this.tipoServico = tipoServico;
    this.transportePessoas = transportePessoas;
    this.veiculo = veiculo;
    this.servicoSubCliente = servicoSubCliente;
    this.tipoLocalRemocao = tipoLocalRemocao;
    this.liberadoRemocao = liberadoRemocao;
    this.rodaTravada = rodaTravada;
    this.veiculoEletrico = veiculoEletrico;
    this.veiculoBlindado = veiculoBlindado;
    this.veiculoCarregado = veiculoCarregado;
    this.amperagemVeiculo = amperagemVeiculo;
    this.possuiFerramenta = possuiFerramenta;
    this.cliente = cliente;
    this.idPrestador = idPrestador;
  }

  public static criarSolicitacaoBateria(
    idServico: number|undefined,
    idCliente: number,
    localizacao: LocalizacaoDTO,
    veiculo: VeiculoDTO,
    contato?: ContatoDTO,
    servicoSubCliente?: ServicoSubClienteDTO,
    veiculoEletrico?: boolean,
    amperagemVeiculo?: String,
    clienteAdministrativo?: ClienteAdministrativoDTO) {
    return new SolicitacaoServicoDTO(
      idServico,
      idCliente,
      getEnumNameByDescription(TipoServicoEnum.BATERIA),
      localizacao,
      undefined,
      contato,
      undefined,
      undefined,
      undefined,
      undefined,
      veiculo,
      servicoSubCliente,
      undefined,
      undefined,
      undefined,
      veiculoEletrico,
      amperagemVeiculo,
      undefined,
      undefined,
      undefined,
      clienteAdministrativo
    )
  }

  public static criarSolicitacaoChaveiro(
    idServico: number|undefined,
    idCliente: number,
    localizacao: LocalizacaoDTO,
    veiculo: VeiculoDTO,
    motivo: string,
    contato?: ContatoDTO,
    servicoSubCliente?: ServicoSubClienteDTO,
    clienteAdministrativo?: ClienteAdministrativoDTO) {
    return new SolicitacaoServicoDTO(
      idServico,
      idCliente,
      getEnumNameByDescription(TipoServicoEnum.CHAVEIRO),
      localizacao,
      undefined,
      contato,
      undefined,
      motivo,
      undefined,
      undefined,
      veiculo,
      servicoSubCliente,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      clienteAdministrativo
    )
  }

  public static criarSolicitacaoTrocaPneu(
    idServico: number|undefined,
    idCliente: number,
    localizacao: LocalizacaoDTO,
    veiculo: VeiculoDTO,
    contato?: ContatoDTO,
    servicoSubCliente?: ServicoSubClienteDTO,
    possuiFerramenta?: boolean,
    clienteAdministrativo?: ClienteAdministrativoDTO) {
    return new SolicitacaoServicoDTO(
      idServico,
      idCliente,
      getEnumNameByDescription(TipoServicoEnum.TROCA_PNEU),
      localizacao,
      undefined,
      contato,
      undefined,
      undefined,
      undefined,
      undefined,
      veiculo,
      servicoSubCliente,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      possuiFerramenta,
      clienteAdministrativo,
    )
  }

  public static criarSolicitacaoGuincho(
    idServico: number|undefined,
    idCliente: number,
    localizacao: LocalizacaoDTO,
    destino: LocalizacaoDTO,
    veiculo: VeiculoDTO,
    associadoNoLocal: boolean,
    motivo: string,
    contato?: ContatoDTO,
    servicoSubCliente?: ServicoSubClienteDTO,
    tipoLocalRemocao?: string,
    liberadoRemocao?: boolean,
    rodaTravada?: boolean,
    veiculoEletrico?: boolean,
    veiculoBlindado?: boolean,
    veiculoCarregado?: boolean,
    clienteAdministrativo?: ClienteAdministrativoDTO,
    idPrestador?: number
  ) {
    return new SolicitacaoServicoDTO(
      idServico,
      idCliente,
      getEnumNameByDescription(TipoServicoEnum.GUINCHO),
      localizacao,
      associadoNoLocal,
      contato,
      destino,
      motivo,
      undefined,
      undefined,
      veiculo,
      servicoSubCliente,
      tipoLocalRemocao,
      liberadoRemocao,
      rodaTravada,
      veiculoEletrico,
      undefined,
      veiculoBlindado,
      veiculoCarregado,
      undefined,
      clienteAdministrativo,
      idPrestador
    )
  }

  public static criarSolicitacaoTransportePessoas(
    idServico: number|undefined,
    idCliente: number,
    localizacao: LocalizacaoDTO,
    destino: LocalizacaoDTO,
    nomeSolicitante: string,
    transportePessoas: TransportePessoasDTO,
    contato?: ContatoDTO,
    servicoSubCliente?: ServicoSubClienteDTO) {
    return new SolicitacaoServicoDTO(
      idServico,
      idCliente,
      getEnumNameByDescription(TipoServicoEnum.TRANSPORTE_ASSOCIADO),
      localizacao,
      undefined,
      contato,
      destino,
      undefined,
      nomeSolicitante,
      transportePessoas,
      undefined,
      servicoSubCliente
    )
  }
}
